<form #form class="form form--color-{{ color }} form--gap-{{ gap }}" (ngSubmit)="submit()">
  <ng-content></ng-content>
</form>
